<template>
  <input-select
    id="input:idConta"
    v-model="payload.idConta"
    :items="idContaOptions"
    :rules="[requiredRule]"
    :loading="loading"
    label="Conta"
    required
  />
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import InvoiceAccountRequest from '@/app/modules/cardhub/invoice/account/InvoiceAccountRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';

export default {
  name: 'SelectContaId',
  mixins: [RulesMixin, RequestSelectMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          idConta: '',
        };
      },
    },
  },
  data: () => ({
    idContaOptions: [],
    requestClass: InvoiceAccountRequest,
    loading: false,
    contaMessageError: 'Falha ao buscar contas!',
  }),
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.makeRequest();
    },
    makeRequest() {
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions(
          'idContaOptions',
          'account',
        ),
        this.contaMessageError,
        this.requestCallBack,
      );
    },
    requestCallBack() {
      this.loading = false;
    },
  },
};
</script>
